<template>
  <div>
    <div class="form-group">
      <vue-tags-input
        v-model="tag"
        placeholder="john@mail.com"
        :tags="tags"
        :validation="validation"
        @tags-changed="newTags => tags = newTags"
      />
    </div>
    <div class="text-center">
      <button type="button" class="btn btn-primary" @click="doSendInvite(ta)">
        Send Invite
      </button>
      <button type="button" class="btn btn-cancel" @click="doCancel()">
        Cancel
      </button>
    </div>
  </div>
</template>

<script>
import VueTagsInput from '@johmun/vue-tags-input'

export default {
  components: {
    VueTagsInput,
  },
  data() {
    return {
      validation: [
        {
          classes: 'invalid-email',
          rule: /\S+@\S+\.\S+/,
          disableAdd: true,
        },
        {
          classes: 'no-braces',
          rule: ({ text }) => text.indexOf('{') !== -1 || text.indexOf('}') !== -1,
        }
      ],
      tag: '',
      tags: []
    }
  },
  props: {
    // tag: String,
    // tags: Array,
    doSendInvite: Function,
    doCancel: Function
  }
}
</script>



// WEBPACK FOOTER //
// src/components/passes/PassInviteEmailForm.vue